<script setup lang="ts">
import { ref, watch } from "vue";
import { CloseButton } from "@/ts/components/elements";
import { useEventBus } from "@vueuse/core";
import { useScrollLock } from "@vueuse/core";

const bus = useEventBus<string>("hamburger");

const slideout = ref<HTMLElement | null>(null);
const body = ref<HTMLElement>(document.body);

const bodyScrollLocked = useScrollLock(body);

interface Props {
    show: boolean;
    showClose?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    showClose: true,
});

watch(
    () => props.show,
    (show) => {
        if (show === false) {
            bus.emit("hamburger-close");
            bodyScrollLocked.value = false;
        } else {
            bodyScrollLocked.value = true;
        }
    },
);
</script>

<template>
    <div class="slideout-container" @click="$emit('close')" :class="{ show: show }">
        <div class="slideout" ref="slideout" @keyup.esc="$emit('close')" tabindex="0" @click.stop>
            <close-button v-if="showClose" @close="$emit('close')"></close-button>
            <div class="slideout-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.slideout-container {
    width: 100vw;
    height: calc(100vh);
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    z-index: 997;
    transition: background-color 0.3s;

    @media screen and (min-width: theme("screens.md")) {
        top: 0;
    }

    @apply focus:outline-none focus:ring-0;

    &.show {
        pointer-events: all;
        background-color: rgba(36, 37, 31, 0.72);
        //backdrop-filter: saturate(100%) blur(10px);

        .slideout {
            opacity: 1;
        }
    }

    .slideout {
        position: absolute;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100vw;
        opacity: 0;
        top: 0;
        background: theme("colors.pink");
        transition: all 0.3s ease-in-out;
        overflow-y: hidden;
        overflow-x: hidden;

        @apply focus:outline-none focus:ring-0;

        .slideout-content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
